// extracted by mini-css-extract-plugin
export var container = "_c8-0";
export var containerTopRight = "_c8-1";